import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import SelectedCategoryItem from "../Components/mcsselectedcategory";
import axios from 'axios';
import { translate } from "../Services/translation";

export default function MCSGeneratorContainer() {

    const activeChannelId = useSelector((state) => state.channel.activeChannelId);

    const [availableFilters, setAvailableFilters] = useState([]);
    const [availableCategories, setAvailableCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selection, setSelection] = useState([]);
    const [showCategoryList, setShowCategoryList] = useState(false);
    const [showSave, setShowSave] = useState(false);
    const [genStatus, setGenStatus] = useState();
    const [importing, setIsImporting] = useState(false);
    const [uploaded, setUploaded] = useState(false);
    const [latestFile, setLatestFile] = useState("");

    useEffect(() => {
        axios.get(`/api/mcs/getavailablecategories`)
            .then(res => {
                generatedFileExists();
                setAvailableCategories(res.data.availableCategories);
            })
    }, []);

    const generatedFileExists = () => {
        return axios.get(`/api/mcs/getgeneratedfile`)
            .then(res => {
                if (!res.data) {
                    setUploaded(false);
                }
                else {                    
                    setUploaded(true);
                    setLatestFile("mcsgen_" + res.data);
                }
            })
    }

    const downloadGeneratedFile = () => {
        return axios({
                url: '/api/mcs/downloadgeneratedfile',
                method: 'GET',
                responseType: 'blob',
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'mcs-generated-pages.xls');
                document.body.appendChild(link);
                link.click();
            })
    }

    const automaticallyGenerateLandingpages = (e) => {
        setShowSave(false);
        setGenStatus("Generator started, polling for status...");
        setIsImporting(true);
        const interval = setInterval(() => {
            axios.get(`/api/mcs/getgeneratorstatus`)
            .then(function (response) {
                if(response){
                    if(response.data === 'DONE'){
                        clearInterval(interval);
                        setGenStatus("Done!");
                        setTimeout(() => {
                            setIsImporting(false);
                            generatedFileExists();
                        }, 1500);
                    }else{
                        setGenStatus(response.data);
                    }   
                } 
              })
              .catch(function (error) {
                setIsImporting(false);
                clearInterval(interval);
                          });
        }, 1000);

        let url = '/api/mcs/generate/' + activeChannelId;
        axios({
            url: url,
            data: selection,
            method: 'POST',
        }).then((response) => {
            if(response.status == 200){
                
            }                  
        }).catch(e => {
            console.log(e);
            setIsImporting(false);
        })


        return () => clearInterval(interval);
    }

    const toggleMenus = () => {
        setShowCategoryList(!showCategoryList);
    }

    const addCategoryToSelection = (cat) => {
        let item = {
            categoryId: cat.id,
            channelId: activeChannelId
        }
        
        axios.post("/api/mcs/getAvailableFiltersForItem", item)
        .then(res => {
            cat.availableFilters = res.data;
        })

        setSelectedCategories(selectedCategories => [...selectedCategories, cat]);
        setShowSave(true);
    }

    const checkIfAlreadySelected = (item) => {
        return selectedCategories && selectedCategories.includes(item);
    }

    const removeAllCategories = () => {
        setSelectedCategories([]);
        setShowSave(false);
    }

    return (
        <div className="mcs-settings-container__generate-pages-container mcs-settings-container__result-wrapper">
            <div className="mcs__filter-wrapper">
                <div className="mcs__filter-controller" onClick={() => toggleMenus()}>
                    <span>{translate("mcs.generate.selectcategories")}</span>
                    <i className={showCategoryList ? "fas fa-chevron-down rotate-180" : "fas fa-chevron-down"}></i>
                </div>
                {availableCategories && availableCategories.length > 0 &&
                    <div className={showCategoryList ? "mcs__filter-list mcs__filter-list--show" : "mcs__filter-list"}>
                        {availableCategories.map((item, index) => (
                            checkIfAlreadySelected(item)
                                ?
                                <span key={"category-" + index} className="mcs__filter-object--item disabled">{item.name}</span>
                                :
                                <span key={"category-" + index} className="mcs__filter-object--item" onClick={() => addCategoryToSelection(item)}>{item.name}</span>
                        ))}
                    </div>
                }
            </div>
            {selectedCategories.map((item) => (
                <SelectedCategoryItem selection={selection} setSelection={setSelection} cat={item} />
            ))}
            
            {showSave && !importing &&
                <div className="mcs__edited-container mcs__container col-12"><div onClick={(e) => automaticallyGenerateLandingpages(e)}>{translate("mcs.generate")}</div><div onClick={() => removeAllCategories()}>{translate("mcs.cancel")}</div></div>
            }
            {importing &&
                <div className="mcs__generator">
                    {genStatus != 'Done!' ? <i className="fas fa-cog fa-spin"></i> : <i className="fas fa-check"></i>}
                    {genStatus}
                </div>
            }

            {uploaded && !importing &&
                <div className="row mcs__generated-file">
                    <div className="mcs__generated-file--date col-6"><span>{latestFile}</span></div>
                    <div className="mcs__generated-file--download mcs__edited-container mcs__container col-6">
                        <div onClick={(e) => downloadGeneratedFile(e)}>{translate("mcs.generate.download")}</div>              
                    </div>
                </div>
            }
        </div>
    );
}